import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';
import { AuthJWTService } from './jwt/auth-jwt.service';
import { AuthMSALService } from './msal/auth-msal.service';

@Injectable()
export class AuthGuardUser implements CanActivate, CanActivateChild {

  constructor(public authService: AuthService,
              private readonly authJwtService: AuthJWTService,
              private readonly authMSAL: AuthMSALService,
              private readonly router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authJwtService.isAuthenticated()) {
      return this.authService.isUser();
    } else {
      localStorage.removeItem('userToken');
      this.router.navigate([ '/login' ], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authJwtService.isAuthenticated()) {
      return this.authService.isUser();
    } else {
      localStorage.removeItem('userToken');
      this.router.navigate([ '/login' ], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/core/auth/auth-guard-user.service.ts